// ═══════════════════════════════════════════════════════════════
// V·IANet Flow — Node Components Barrel Export + nodeTypes map
// ═══════════════════════════════════════════════════════════════

import { ActivityNode } from './ActivityNode';
import { DecisionNode } from './DecisionNode';
import { DocumentNode } from './DocumentNode';
import { SubprocessNode } from './SubprocessNode';
import { StartNode } from './StartNode';
import { EndNode } from './EndNode';
import { ProcessRefNode } from './ProcessRefNode';
import { GovernanceNode } from './GovernanceNode';
import { ResultNode } from './ResultNode';

export {
  ActivityNode,
  DecisionNode,
  DocumentNode,
  SubprocessNode,
  StartNode,
  EndNode,
  ProcessRefNode,
  GovernanceNode,
  ResultNode,
};

export const NODE_TYPES = {
  ACTIVIDAD: ActivityNode,
  DECISION: DecisionNode,
  INICIO: StartNode,
  FIN: EndNode,
  DOCUMENTO: DocumentNode,
  SUBPROCESO: SubprocessNode,
  PROCESO_GOBIERNO: GovernanceNode,
  PROCESO_REF: ProcessRefNode,
  RESULTADO: ResultNode,
};
